import Service			from "../../Libs/Service";
import _				from "lodash";

import { Project }		from "./Project";
import { Layout } 		from "./Layout";
import Broadcast        from "../../Libs/Broadcast";

let Tracking = new Service({

	Name: "Tracking",

	Events: {

	},

	Actions: {
        'NativeTrackingAvaibilityStatus': function(data) {
            Broadcast.call('Tracking Avaibility Status Changed', [data]);
        }
    },

    init() {
    },

    async getAvaibility() {
    }
});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Tracking) Tracking = window.Tracking;
else window.Tracking = Tracking;

export { Tracking }

